<template>
  <VerticalContainer is-editing>
    <Table
      :headers="headers"
      first-column-width="30%"
      :rows="rows"
      :is-editing="true"
      @onChange="onChange"
    />
    <ErrorMessage :error-message="errorToDisplay" />
    <template #buttons>
      <Button
        text="Save"
        :on-click="save"
        :is-loading="isLoading"
      />
      <Button
        text="Cancel"
        :on-click="cancelClick"
        :disabled="isLoading"
      />
    </template>
    <YesNoDialogue
      :is-visible="isCancelDialogueVisible"
      message="Any unsaved data will be lost"
      @no="() => isCancelDialogueVisible = false"
      @yes="goToZonesHome"
    />
  </VerticalContainer>
</template>

<script>
import VerticalContainer from '../../components/organisms/layout/vertical-container';
import Table from '../../components/atoms/table/table';
import ErrorMessage from '../../components/atoms/message/error-message';
import Button from '../../components/atoms/button/button';
import YesNoDialogue from '../../components/molecules/dialogues/yes-no-dialogue';
import rules from '../../mixins/input-validation-rules';
import { routeNames } from '../../constants';

export default {
  name: 'AddZone',
  components: {
    VerticalContainer,
    Button,
    ErrorMessage,
    Table,
    YesNoDialogue,
  },
  mixins: [rules],
  props: {
    gateway: { type: Object, default: null },
  },
  data() {
    const rows = [{
      name: 'Name',
      value: '',
      placeholder: 'Insert name',
      isEditable: true,
    }];
    if (this.gateway !== null) {
      rows.push({ name: 'Gateway status', value: 'Linking gateway...' });
    }
    return {
      zoneName: '',
      nameErrorMessage: '',
      rows,
      isCancelDialogueVisible: false,
    };
  },
  computed: {
    headers() {
      return [{ key: 'name' }, { key: 'value' }];
    },
    isLoading() {
      return this.$store.state.zones.isLoadingZone;
    },
    serverErrorMessage() {
      return this.$store.state.zones.errorMessage;
    },
    errorToDisplay() {
      return [this.nameErrorMessage, this.serverErrorMessage]
        .filter((message) => message && message !== '')
        .join(', ');
    },
    hasError() {
      return this.errorToDisplay !== '';
    },
  },
  destroyed() {
    this.$store.commit('zones/CLEAR_ERROR_MESSAGE');
  },
  methods: {
    onChange({ value }) {
      this.zoneName = value;
      this.rows.find(({ name }) => name === 'Name').value = value;
      this.resetNameError();
    },
    resetNameError() {
      this.nameErrorMessage = '';
    },
    async save() {
      const isNameValid = this.validateName(this.zoneName);
      if (isNameValid === true) {
        const newZone = await this.$store.dispatch('zones/addZone', {
          name: this.zoneName,
          gateway: this.gateway,
        });
        if (!this.hasError) {
          this.goToZonesHome();
          this.$root.trackEvent.addedZone(newZone);
          if (this.gateway) {
            const { gatewayId } = newZone.gateways.filter(
              ({ removedOn }) => removedOn === null,
            )[0];
            this.$root.trackEvent.linkedGateway(newZone, gatewayId, true);
          }
        }
      } else {
        this.nameErrorMessage = isNameValid;
      }
    },
    cancelClick() {
      if (this.zoneName !== '' || this.gateway !== null) {
        // open modal
        this.isCancelDialogueVisible = true;
      } else {
        this.goToZonesHome();
      }
    },
    goToZonesHome() {
      this.$router.replace({ name: routeNames.zones.list });
    },
  },
};
</script>
